import {
  otherRouter,
  appRouter
} from '@/router/router';
import Util from '@/libs/util';
import Cookies from 'js-cookie';
import Vue from 'vue';
import misc from '@/libs/misc'
import {_commSocket, webkitLoad} from '@/libs/websocket';

const app = {
  state: {
    cachePage: [],
    lang: '',
    isFullScreen: false,
    openedSubmenuArr: [], // 要展开的菜单数组
    menuTheme: 'light', // 主题
    themeColor: '',
    navigationMeetingId: "",
    meetingTemplateId: "",
    klksituationId:null,
    navigationId: "",
    isMeetingRelatedUserId: false, //会议下是否有人员
    isNavigationAppoint: false,//向导添加会议时是否为预约会议
    pageOpenedList: [{
      title: '系统首页',
      path: '',
      name: 'home_index'
    }],
    currentPageName: '',
    currentPath: [{
      title: '系统首页',
      path: '',
      name: 'home_index'
    }], // 面包屑数组
    menuList: [],
    routers: [
      otherRouter,
      ...appRouter
    ],
    tagsList: [...otherRouter.children],
    messageCount: 0,
    dontCache: ['text-editor', 'artical-publish'], // 在这里定义你不想要缓存的页面的name属性值(参见路由配置router.js)
    // 变量
    wizardStepNumTemp: 0, // 会议向导跳转到第几步
    systemStepNumTemp: 0, // 会议向导跳转到第几步
    sceneStepNumTemp:0,   //可立控场景跳转到第几步
    showLoading: false, //加载中
    showLoadText: "资料上传中", // 加载的提示语
    //会议室id
    meetingRoomId: 0,
    //会议室编号
    meetingRoomNo: 0,
    // 会议室名称
    meetingRoomName: "",
    // meetingRoomNum: 0, //标识第几次更改会议室，如果是0表示刚进页面不会直接调用刷新页面
    meetingRoomList: [
      /*{
                      pkid: 1,
                      roomName: "1号会议室"
                  },
                  {
                      pkid: 2,
                      roomName: "2号会议室"
                  }*/
    ],
    reload: true, //刷新当前页面用
    editStep: {}, //前后屏模板编辑数据
    modelesArr: [], // 权限数据
    userFormArr:{},  //当前登录人员的消息
    permissions: [], //页面权限数据
    servicePath: "", //WEBSOCKET服务端地址 切换会议室时会被替换
    ControlCenter: null,//
    currentPage: -1,//判断向导在哪个步骤
    slicingOper: {
      slicingCode: -1,//切片的状态。
      operateId: -1,//当前正在操作的切片id
      processResult:0,// 文件切图方式
    },
    isConnect: true,//是否连接服务器
    audioObj: null,//提示音对象
    enums: {},
    nowVue: null,
    isWeek: false,
    canAudit: 0,
    calendarDate: [],
    specialCharacterConfig: false,
    voiceMeeting: "false",
    judgeJB: false,
    encryptLevelSwitch: false,   // 是否开启密级
    userImgUrl: "",      // 部分照片使用路径
    runningSysVer:[],    //平板运行系统
    isMdmSelected:false,    // 在会议配置中是否选中mdm配置页
  },
  mutations: {
    setIsMdmSelected(state , value){
      state.isMdmSelected = value
    },
    setUserImgUrl(state , value){
      state.userImgUrl = value
    },
    setSpecialCharacterConfig(state, value) {
      state.specialCharacterConfig = value;
    },
    setVoiceMeetingConfig(state, value) {
      state.voiceMeeting = value;
    },
    changeCanAudit(state, audit) {
      state.canAudit = audit;
      sessionStorage.setItem("audit", audit)
    },
    initCanAudit(state) {
      state.canAudit = sessionStorage.getItem('audit');
    },
    changeisWeek(state, flag) {
      state.isWeek = flag;
    },
    changeCalendarData(state, arr) {
      state.calendarDate = arr;
    },
    setEnums(state, obj) {
      state.enums = obj;
    },
    setAudioObj(state,obj){
      state.audioObj = obj;
    },
    changeConect(state,flag){
      state.isConnect = flag;
    },
    initSlicingOper(state){
      state.slicingOper={
        slicingCode:-1,//切片的状态。
        operateId:-1,//当前正在操作的切片id
        processResult:0,// 文件切图方式
      }
    },
    setSlicingCode(state,obj){
        state.slicingOper.slicingCode = obj.code; //设置切片状态;
        state.slicingOper.operateId = obj.id;//设置正在操作的切片id;
        state.slicingOper.processResult = obj.processResult;//设置文件切图方式
    },
    // 设置中控对象
    setControlCenter(state,obj){
      state.ControlCenter = obj;
    },
    // 会议向导等步骤，当前步骤
    setCurrentPage(state,num){
      state.currentPage = num;
    },
    setWizardStepNumTemp(state, val) {
      state.wizardStepNumTemp = val;
    },
    setServicePath(state, obj) {
      state.servicePath = obj.address;
      if(obj.address!==""){
        misc.getMeetingByRoom(obj.vm, state.meetingRoomNo, meeting => {
          let meetingId = 0;
          if(meeting != null && meeting != "" && meeting.pkid != "") {
            meetingId = meeting.pkid;
          }
          webkitLoad(null, {Rooms:state.meetingRoomNo, Meeting: meetingId, ClientType: state.enums['clientType']['SYSTEM']}, obj.vm);
          Vue.prototype.$_commSocket = _commSocket;
        })
      }else{
        console.error("websocket地址无效:",obj.address)
      }

    },
    // setPermissions(state, data) {
    //   state.permissions = data;
    //   sessionStorage.permissions = data;
    // },
    setModelesArr(state, data) {
      state.modelesArr = data;
      localStorage.modelesArr = JSON.stringify(data);
    },
    setUserFormArr(state, data) {
      state.userFormArr = data;
    },
    //刷新初始化权限数据
    setEditStep(state, obj) {
      state.editStep = obj;
      sessionStorage.setItem("editStep", JSON.stringify(obj));
    },
    setMeetingRoomList(state, data) {
      state.meetingRoomList = data;
    },
    // 初始化平板运行系统
    setRunningSysVer(state, data){
      state.runningSysVer = data;
    },
    toggleReload(state, {vm,fn}) {
      // console.log("state.meetingRoomNum:", state.meetingRoomNum);
      //防止刷新后调用on-change事件 会导致两次刷新
      // if (state.meetingRoomNum == 0) {
      // state.meetingRoomNum += 1;
      // } else {

      state.reload = false
      vm.$nextTick(function () {
        state.reload = true;
        if(fn){
          fn();
        }
      })
      // }

    },
    setMeetingRoomId(state, value) {
      state.meetingRoomId = value;
      localStorage.meetingRoomId = value;
    },
    setMeetingRoomNo(state, value) {
      state.meetingRoomNo = value;
      localStorage.meetingRoomNo = value;
    },
    setMeetingRoomName(state, value) {
      state.meetingRoomName = value;
      localStorage.meetingRoomName = value;
    },
    initMeetingNum(state) {
      if (localStorage.meetingRoomId) {
        //console.log(localStorage.meetingRoomId)
        state.meetingRoomId = localStorage.meetingRoomId;
      }
      if (localStorage.meetingRoomNo) {
        state.meetingRoomNo = localStorage.meetingRoomNo;
      }
    },
    changeShowLoading(state, obj) {
      obj.text = obj.text == "" ? "资料上传中" : obj.text;
      state.showLoading = obj.status;
      state.showLoadText = obj.text;
    },
    setNavigationMeetingId(state, id) {
      state.navigationMeetingId = id
    },
    setMeetingTemplateId(state, id) {
      state.meetingTemplateId = id;
    },
    // 可立控id
    setKlksituationId(state, id){
      state.klksituationId = id
    },
    setNavigationId(state, id) {
      state.navigationId = id;
    },
    setTagsList(state, list) {
      state.tagsList.push(...list);
    },
    setIsMeetingRelatedUserId(state, status) {
      state.isMeetingRelatedUserId = status;
    },
    setIsNavigationAppoint(state, status) {
      state.isNavigationAppoint = status;
    },
    updateMenulist(state) {
      let userCount = Cookies.get('userCount');
      let menuList = [];
      let modelesArr = state.modelesArr
      let userName = Cookies.get('user');
      let userType = sessionStorage.getItem("userType");
      // console.log('appRouter:',appRouter,appRouter.length);
      let setUserIds = localStorage.getItem("setUserIds")
      let userNames = localStorage.getItem("userNames")
      let userTypes = localStorage.getItem("userTypes")
      if(!userType){
        sessionStorage.setItem("setUserIds", setUserIds);
        sessionStorage.setItem("userName", userNames);
        sessionStorage.setItem("userType", userTypes);
      }
      // 只有超管才可展示的页面
      let adminIdentityList = [
        // "system-format", // 文件格式管理
        // "system-power", // 角色管理
      ]

      // 系统管理员、保密管理员、审计管理员展示路由
      let adminRouterList = [];

      let _isXtAdmin = Vue.prototype.$_isXtAdmin();
      let _isBmAdmin = Vue.prototype.$_isBmAdmin();
      let _isSjAdmin = Vue.prototype.$_isSjAdmin();

      // 系统管理员页面路由
      // if (_isXtAdmin) {
      //   adminRouterList = _isXtAdmin;
      // }

      // // 保密管理员页面路由
      // if (_isBmAdmin) {
      //   adminRouterList = _isBmAdmin;
      // }

      // // // 审计管理员页面路由
      // if (_isSjAdmin) {
      //   adminRouterList = _isSjAdmin;
      // }
      // console.log(JSON.parse(JSON.stringify(appRouter)) )
      // console.log(JSON.parse(JSON.stringify(modelesArr)))

      var router=JSON.parse(JSON.stringify(appRouter))
      var modelesArr1=JSON.parse(JSON.stringify(modelesArr))

      function addIsShowProperty(arr1, arr2) {
          // Helper function to find if a path exists in the second array
          function pathExistsInArray(path, array) {
              for (let item of array) {
                  if (item.path === path) {
                      return true;
                  }
                  if (item.children && pathExistsInArray(path, item.children)) {
                      return true;
                  }
              }
              return false;
          }
      
          // Recursive function to add isShow property
          function processArray(array) {
              for (let item of array) {
                  item.isShow = pathExistsInArray(item.path, arr2);
                  if (item.children) {
                      processArray(item.children);
                  }
              }
          }
      
          // Process both arrays
          processArray(arr1);
          processArray(arr2);
      }
    
    
      addIsShowProperty(router, modelesArr1);
    
      // console.log(JSON.parse(JSON.stringify(router)))
      router.forEach((item, index) => {
        let len = menuList.push(item);
        let childrenArr = [];

        // if(!item.children){
        //   item.children=[{
        //     icon:item.icon,
        //     title:item.name,
        //     name:item.name,
        //     path:item.path
        //   }]
        // }

        item.children.forEach(c => {
          if (!state.enums.userType) {
            return
          }

          // 判断是否是超级管理员账号id
          // if (userType == state.enums.userType.superManager) {
          //   item.isShow=true
          //   c.isShow=true
          //   childrenArr.push(c);
          // } else {

            let currAcc = c.path;

            // console.log(currAcc)
            //如果是首页 直接push
            if (currAcc == 'home') {
              childrenArr.push(c);
            }
            // 系统管理员、保密管理员、审计管理员展示路由
            // adminRouterList.map((list)=>{
            //   if (currAcc == list || currAcc.indexOf(list) >= 0) {
            //     item.isShow=true
            //     c.isShow=true
            //     childrenArr.push(c);
            //   }
            // })

            // if (_isXtAdmin || _isBmAdmin || _isSjAdmin) {
            //   return
            // }
            modelesArr.forEach(list => {
              if(list.children){
                list.children.map(keys=>{
                  // 不是超级管理员去除文件格式管理
                  // if (adminIdentityList.indexOf(keys.path) != -1) {

                  //   return
                  // }else{

                  // }

                  if (currAcc == keys.path || currAcc.indexOf(keys.path) >= 0) {
                    childrenArr.push(c);
                  }
                })
              }
            })
          // }
        });


        if (childrenArr === undefined || childrenArr.length === 0) {
          // menuList.splice(len - 1, 1);
        } else {
          //去重
          let handledItem = JSON.parse(JSON.stringify(menuList[len - 1]));
          var hash = {};
          if (childrenArr.length > 1) {
            childrenArr = childrenArr.reduce(function (item, next) {
              // console.log(next.name)
              // console.log(hash,hash[next.name],"显示的内容")
              hash[next.name] ? '' : hash[next.name] = true && item.push(next);


              return item
            }, []);
          }
          // console.log(childrenArr,"最终的数据")
          handledItem.children = childrenArr;
          var hash = {}; //arr是要去重的对象数组

          menuList.splice(len - 1, 1, handledItem);
        }

        // }
      });

      // console.log(menuList,'最终')
      state.menuList = menuList;
    },
    changeMenuTheme(state, theme) {
      state.menuTheme = theme;
    },
    changeMainTheme(state, mainTheme) {
      state.themeColor = mainTheme;
    },
    addOpenSubmenu(state, name) {
      let hasThisName = false;
      let isEmpty = false;
      if (name.length === 0) {
        isEmpty = true;
      }
      if (state.openedSubmenuArr.indexOf(name) > -1) {
        hasThisName = true;
      }
      if (!hasThisName && !isEmpty) {
        state.openedSubmenuArr.splice(0, state.openedSubmenuArr.length); // 打开哪个子菜单 这个数组就等于哪个子菜单的name ,解决一下子打开多个菜单
        state.openedSubmenuArr.push(name);
      }
    },
    closePage(state, name) {
      state.cachePage.forEach((item, index) => {
        if (item === name) {
          state.cachePage.splice(index, 1);
        }
      });
    },
    initCachepage(state) {
      if (localStorage.cachePage) {
        state.cachePage = JSON.parse(localStorage.cachePage);
      }
    },
    removeTag(state, name) {
      state.pageOpenedList.map((item, index) => {
        if (item.name === name) {
          state.pageOpenedList.splice(index, 1);
        }
      });
    },
    // 标签缓存 刷新页面后标签页还是原来的
    pageOpenedList(state, get) {
      let openedPage = state.pageOpenedList[get.index];
      //console.log(get)
      if (get.argu) {
        openedPage.argu = get.argu;
      }
      if (get.query) {
        openedPage.query = get.query;
      }
      state.pageOpenedList.splice(get.index, 1, openedPage);
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
    },
    clearAllTags(state) {
      state.pageOpenedList.splice(1);
      state.cachePage.length = 0;
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
    },
    clearOtherTags(state, vm) {
      let currentName = vm.$route.name;
      let currentIndex = 0;
      state.pageOpenedList.forEach((item, index) => {
        if (item.name === currentName) {
          currentIndex = index;
        }
      });
      if (currentIndex === 0) {
        state.pageOpenedList.splice(1);
      } else {
        state.pageOpenedList.splice(currentIndex + 1);
        state.pageOpenedList.splice(1, currentIndex - 1);
      }
      let newCachepage = state.cachePage.filter(item => {
        return item === currentName;
      });
      state.cachePage = newCachepage;
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
    },
    setOpenedList(state) {

      state.pageOpenedList = localStorage.pageOpenedList ? JSON.parse(localStorage.pageOpenedList) : [otherRouter.children[0]];
    },
    initOpenedList(state) {
      state.pageOpenedList = [{
        title: '系统首页',
        path: '',
        name: 'home_index'
      }]
    },
    setCurrentPath(state, pathArr) {
      state.currentPath = pathArr;
    },
    setCurrentPageName(state, name) {
      state.currentPageName = name;
    },
    setAvator(state, path) {
      localStorage.avatorImgPath = path;
    },
    switchLang(state, lang) {
      state.lang = lang;
      Vue.config.lang = lang;
    },
    clearOpenedSubmenu(state) {
      state.openedSubmenuArr.length = 0;
    },
    setMessageCount(state, count) {
      state.messageCount = count;
    },
    //当点击菜单时，创建新的标签页
    increateTag(state, tagObj) {
      if (!Util.oneOf(tagObj.name, state.dontCache)) {
        state.cachePage.push(tagObj.name);
        localStorage.cachePage = JSON.stringify(state.cachePage);
      }
      state.pageOpenedList.push(tagObj);
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
    },
    setNowVue(state, obj) {
      state.nowVue = obj;
    },
    //点击开启全局提示

    // 判断是否是简报
    judgeJB(state){
      if(JSON.parse(localStorage.modelesArr).length==0){
        state.judgeJB=false
      }else {
        for(var i=0;i<JSON.parse(localStorage.modelesArr).length;i++){
          if(JSON.parse(localStorage.modelesArr)[i].children){
            for(var j=0;j<JSON.parse(localStorage.modelesArr)[i].children.length;j++){
              if(JSON.parse(localStorage.modelesArr)[i].children[j].code=="M_Bulletin_Briefing"){
                // console.log(JSON.parse(localStorage.modelesArr)[i].children[j])
                state.judgeJB=true
                // console.log(this.$store.state.app.judge)
              }
            }
          }


        }
      }

    }

  },
  actions: {

    getUserImgUrl(context, obj){
      obj.vm.$app.post('/system/findUploadUrl')
        .then(res => {
          if (res.data.code == 0) {
            localStorage.setItem("setUserImgUrl", res.data.data);
            context.commit('setUserImgUrl', res.data.data);
          }
        })
    },

    getMeetingRoomList(context, vm) {
      //获取全部会议室
      misc.findBoardRoomAll(vm, (res) => {
        if (res.code == 0) {
          context.commit("setMeetingRoomList", res.data);
          let currentRoom = JSON.parse(localStorage.getItem("currentRoom"));
          if (!currentRoom && res.data[0]) {
            let data = {
              pkid: res.data[0].id,
              roomNo: res.data[0].roomNo,
              roomName: res.data[0].roomName,
            }
            currentRoom = JSON.stringify(data);

            localStorage.setItem("currentRoom", currentRoom);
          }
          if(currentRoom){
            if (!currentRoom.pkid) {
              currentRoom = JSON.parse(currentRoom);
            }
            context.commit("setMeetingRoomNo", currentRoom.roomNo);
          } else{
            context.commit("setMeetingRoomNo", null);
          }

          //获取当前操作的会议室
          misc.findCurrBoardRoom(vm, (res) => {
            if (res.code == 0) {
              context.commit("setMeetingRoomId", res.data.pkid);
              context.commit("setMeetingRoomNo", res.data.roomNo);
              localStorage.setItem("layoutBackgroundPath", res.data.layoutBackgroundPath);
              //重新获取websocket地址
              misc.getSocketInfo(vm, res => {
                if (res.code == 0) {
                  context.commit("setServicePath", {address:res.data.wAddress,vm:vm});
                } else {
                  context.commit("setServicePath", {address:"",vm:vm});
                }

              });
            }
          });
        }
      });

    },
    // 获取枚举类
    getEnums(context, obj){
      let vm = obj.vm;
      // 获取枚举类
      misc.getEnums(vm, (res) => {
        if(res.code == 0){
          let emums = {

            //请求状态码
            statusCode: {
              //请求成功
              success: 0,
              //请求失败
              fail: 1,
              //请求未授权
              notPermissions: 2
            },
            //用户类型
            userType: {
              //超级管理员
              superManager: null,
              //系统管理员
              systemManager: null,
              //普通人员
              normal: null,
              //工作人员
              work: null,
              //文秘人员
              clerk: null,
              //内部人员
              XTGLY: null,
              //外部人员
              WBRY: null

            },

            //会议状态
            meetingStatus: {
              //未开始
              notStarted: null,
              //进行中
              progress: null,
              // 预开始
              prepare: null,
              //已结束
              ended: null,
              //已取消
              canceled: null,
              //禁用
              disable: null,
              //未启用
              enabled: null,
            },
            //议题状态
            topicStatus: {
              //已结束
              over: 0,
              //未开始
              normal: 1,
              //进行中
              progress: 2,
              //已删除
              deleted: 4,
              //正常
              regular: 3,
            },
            //投票状态
            voteStatus: {
              //未开始
              notStarted: null,
              //投票中
              progress: null,
              //已完成
              ended: null,
              //已取消
              canceled: null,
            },
            //投票类型
            voteType: {
              //默认项
              DEFAULT: null,
              //自定义
              CUSTOM: null,
            },
            // 离线页面类型
            offlinePageType: {
              // 大屏
              bigscreen: null,
              // 门牌
              doorplate: null,
              // 终端
              node: null
            },
            //终端类型
            nodeType: {
              //升降机
              elevator: null,
              //大屏
              bigScreen: null,
              //PAD
              pad: null,
              //门牌
              doorPlate: null,
              //电视机
              television: null,
              //桌牌
              tablePlate: null,
              //升降桌牌
              liftTablePlate: null,
              //升降麦杆
              liftStraw: null,
            },
            //呼叫状态
            shoutStatus: {
              // 已处理
              PROCESSED: null,
              // 未处理
              UNPROCESSED: null,
            },
            //呼叫类型
            shoutType: {
              //自定义
              ZDY: null,
              //文字
              WZ: null,
              //手写
              SX: null,
            },
            //文件格式类型
            fileModel: {
              //办公
              office: null,
              //视频
              video: null,
              //音频
              audio: null,
              //图片
              image: null,
              //其他
              other: null,
            },
            //用户性别
            userSex: {},
            //切图结果
            slicingResult: {},
            //文件切图状态
            cropStatus: {
              //未切图
              notcrop: null,
              //不切图
              decline: null,
              //切图中
              croping: null,
              //已切图
              already: null,
              //切图失败
              failure: null,
            },
            //文件操作限制
            datumAllowOpt: {
              //查看
              view: null,
              //下载
              download: null,
              //修改
              modify: null,
              //删除
              delete: null,
              //全操作
              all: null,
            },
            // 文件格式限制操作
            fileFormatLimitOpt:{
              // 上传
              UPLOAD:null,
              // 下载
              DOWNLOAD:null,
              // 预览
              PREVIEW:null,
              // 切图
              CUT_PHOTO:null,
              // 批注
              POSTIL:null,
            },
            //注册类型
            clientType: {
              //后台系统  1
              SYSTEM: null,
              //升降机  2
              ELEVATOR: null,
              //PAD 3
              PAD: null,
              //升降机大屏  4
              ELEVATOR_BIG_SCREEN: null,
              //PAD大屏 5
              PAD_BIG_SCREEN: null,
              //候会室  6
              WAIT_ROOM: null,
              //茶水间  7
              TEA_ROOM: null,
              //门牌  8
              DOORPLATE: null,
              //PAD中控 9
              PAD_CONTROL: null,
              //导览屏  11
              GUIDE: null,
              // 会控屏 12
              HG_DEVICE:null,
              //语音服务  13
              ASR_SERVICE:null,
            },
            //会议提醒类型
            remindType: {
              //短信
              sms: null,
              //邮箱
              email: null,
              //手机
              phone: null,
              //微信
              wechat: null
            },
              //平板运行系统类型
              runningSystemVersion: {
              //鸿蒙
              HARMONYOS: null,
              //荣耀
              HONOR: null,
              //联想
              LENOVO: null
            },
            //会议预约状态
            meetingAppointStatus:{
              //审核中
              auditing:null,
              //已通过
              pass:null,
              //未通过
              notPass:null,
              //已取消
              cancel:null
            },
            //会议审核状态
            meetingAuditStatus:{
              //待审批
              wait:null,
              //已通过
              pass:null,
              //未通过
              notPass:null,
              //已取消
              cancel:null,
            },
            //通知类型
            noticeType: {
              //会议通知
              meeting: null,
              //预约待审核
              waitAudit: null,
              //预约通过
              passAudit: null,
              //预约拒绝
              noPassAudit: null,
            },
            //热词类型
            voiceHotWordType: {
              //通用热词
              generic: null,
              //类热词
              classes: null,
            },
            //热词状态
            voiceHotWordStatus: {
              //禁用
              disable: null,
              //启用
              enable: null,
            },
            //业务配置参数类型
            paramConfigBusinessType: {
              //组织
              tenant: null,
              //会议室
              boardroom: null,
              //终端
              node: null,
              //会议
              meeting: null,
            },
            //文件处理方式
            fileProcessMethodEnum: {
              //不处理
              NOT_PROCESS: null,
              //转PDF
              CONVERT_PDF: null,
              //转图片
              CONVERT_SLICING: null,
              //转HTML
              CONVERT_HTML: null,
              //转小图
              CONVERT_SMALL_PICTURE: null,

            },
            // 操作系统
            nodeSystemEnum: {
              // 安卓
              ANDROID: null,
              // 银河麒麟
              KYLIN_OS: null,
              // 统信UOS
              UNIONTECH_OS: null,
              // windows
              WINDOWS: null,
              // linux
              LINUX: null,
              // 鸿蒙
              HARMONY_OS:null,
              // 其他
              OTHER:null,
            },
            // mdm控制项值类型枚举
            mdmItemValueTypeEnum: {
              // 布尔值
              bool: null,
              // 数值
              number: null,
            },
            // 会议室状态类型
            boardRoomStatus:{
              // 禁用
              disable: 3,
              // 启用
              enabled: 1,
              // 未启用
              notEnabled: 0,
              // 使用中
              useing: 2
            },
          };
          if(res.data.length > 0){
            res.data.forEach(item => {
              for (let key in item.enums) {
                if(emums[item.name]){
                  emums[item.name][key] = item.enums[key];
                }
              }
            });
            // 给枚举加上中文名 暂时写死
            emums['nodeTypeName']=[
              {val:1,name:'升降机'},
              {val:2,name:'大屏'},
              {val:3,name:'PAD'},
              {val:4,name:'门牌'},
              {val:5,name:'电视机'},
              {val:6,name:'桌牌'},
              {val:7,name:'升降桌牌'},
              {val:8,name:'升降麦秆'},
              {val:9,name:'墨水屏'},
              {val:10,name:'Linux桌牌'},
              {val:11,name:'导览屏'},
              {val:12,name:'会控'},
            ]
            // 审批类型
            emums['WorkflowRelationTypeEnum']={
              // 会议id
              MEETING_ID: 0,
              // 会议模版id
              MEETING_TEMPLATE_ID: 1,
              // 任务id
              TASK_ID: 2,
              // 会议纪要id
              MINUTES_ID: 3,
              // 议题id
              TOPIC_ID: 4,
              // 任务议题id
              TASK_TOPIC_ID: 5,
            }

             // 审批流程
            emums['WorkflowTypeEnum']={
              // 会议流程
              MEETING_PROCESS: 0,
              // 会议纪要流程
              MINUTES_PROCESS: 1,
              // 议题任务流程
              TASK_PROCESS: 2,
              // 议题审核流程
              REVIEW_PROCESS: 3,
            }

            // 会议最小单位配置
            emums['meetingSource']={
              // 会议
              MEETING: "meeting",
              // 议题
              TOPIC: "topic",
            }

            emums['userRole']={
              // 普通人员
              COMMON_USER: "M_Common_User",
              // 会务人员
              CONFERENCE_COORDINATOR: "M_Conference_Coordinator",
              // 部门管理员
              DEPT_ADMIN: "M_DEPT_ADMIN",
              // 会议秘书
              CONFERENCE_SECRETARY: "M_Conference_Secretary",
              // 借阅管理人员
              BORROWING_COORDINATOR: "M_Borrowing_Coordinator",
            }
            // 会议导出打包状态
            emums['meetingPackageStatus']={
              // 未打包
              unpackaged: 0,
              // 打包中
              InPackaging: 1,
              // 已打包
              packaged: 2,
            }

            context.commit('setEnums', emums);

            // 将数据存到缓存里 防止页面刷新 数据加载过慢读取不到数据的问题
            sessionStorage.setItem('emums', JSON.stringify(emums))
            // 平板运行系统
            let enums = JSON.parse(sessionStorage.getItem("emums"))
            let runningSysVer = []
            for (let key in enums.runningSystemVersion) {
              let name = ""
              switch (key) {
                case "HARMONYOS":
                  name = "鸿蒙"
                  break;
                case "HONOR":
                  name = "荣耀"
                  break;
                case "LENOVO":
                  name = "联想"
                  break;
              }
              runningSysVer.push({
                value: enums.runningSystemVersion[key],
                lable: name
              });
            }
            sessionStorage.setItem('runningSysVer',  JSON.stringify(runningSysVer))
            context.commit("setRunningSysVer", runningSysVer);
          }

          if (obj.callBack) {
            obj.callBack()
          }
        }
      })
    },
    //获取权限列表
    getUserModules(context, obj) {
      obj.vm.$app.post('/permissionInfo')
        .then(res => {
          if (res.data.code == 0) {
            context.commit('setModelesArr', res.data.data.menus);
            context.commit('setUserFormArr', res.data.data.user);
            context.commit('updateMenulist');
            if (obj.callback) {
              obj.callback();
            }
          }
        })
    },
      //全局提醒
      globalNotice(context, obj) {
        //切图成功修改为处理成功
        obj.title=obj.title.replace('切图成功', '处理成功');
        // console.log("globalNotice",obj)
        let states = obj.code==0?"success":"error";

        obj.vm.$Notice[states]({
          title: obj.title,
          duration: 3,
        })
        // console.log($(".ivu-notice-notice").length)
        if ($(".ivu-notice-notice").length > 2) {
          $(".ivu-notice-notice").eq(0).remove();
        }
      },
      getSpecialCharacterConfig(context, obj) {
        var param={}
        param.systemConfigList=[obj.vm.$store.state.configNos.systemConfigNos.special_character_switch]
        obj.vm.$app.post("/config ", param).then(res => {
            if (res.data.code == 0) {
              var systemConfigList=res.data.data.systemConfigList
              systemConfigList.map(item=>{
                if(param.systemConfigList.indexOf(item.configNo)>-1){
                  let value = item.configValue;
                  context.commit('setSpecialCharacterConfig', value && value == "1");
                }
              })
            }
          })
      },
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js